import React from "react";
import { Home } from "lucide-react";

interface EmptyStateMessageProps {
  icon?: React.ReactNode;
  title: string;
  subtitle: string;
  style?: React.CSSProperties;
  animate?: boolean;
}

export const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({
  icon = <Home className="w-7 h-7 text-gray-400" />,
  title,
  subtitle,
  style,
  animate = false,
}) => {
  return (
    <div className="text-center py-12">
      <div className="flex justify-center mb-4">
        <div className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center">
          {icon}
        </div>
      </div>
      <h3 className="text-base lg:text-lg font-semibold mb-1 text-gray-700">
        {title}
      </h3>
      <p className="text-[#6B7280] text-xs lg:text-base">{subtitle}</p>
    </div>
  );
};

export default EmptyStateMessage;
